import React, { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Add_Faqs from "./Components/Add_Faqs";
import Add_SearchMaster from "./Components/Add_SearchMaster";
import AddDesignation from "./Components/AddDesignation";
import AddKB from "./Components/AddKB";
import AddRestaurantNew from "./Components/AddRestaurantNew";
import AddStaff from "./Components/AddStaff";
import AddVacancy from "./Components/AddVacancy";
import CreateInsidePageRights from "./Components/CreateInsidePageRights";
import CreateStaffRights from "./Components/CreateStaffRights";
import CreateSubStaffRights from "./Components/CreateSubStaffRights";
import CreateNewTicket from "./Components/CreateTicket";
import PlanManagement from "./Components/PlanManagement";
import "./Components/Css/AddStaff.css";
import "./Components/Css/AddRestaurantNew.css";
import "./Components/Css/Analytics.css";
import "./Components/Css/AnalyticsNew.css";
import "./Components/Css/Calender.css";
import "./Components/Css/Dashboard.css";
import "./Components/Css/Header.css";
import "./Components/Css/HelpAndSupport.css";
import "./Components/Css/HelpSupport.css";
import "./Components/Css/Loading.css";
import "./Components/Css/Login.css";
import "./Components/Css/Newonboading.css";
import "./Components/Css/Onboading.css";
import "./Components/Css/Pagination.css";
import "./Components/Css/Reports.css";
import "./Components/Css/Reservations.css";
import "./Components/Css/RestoSetup.css";
import "./Components/Css/Settings.css";
import "./Components/Css/SideBar.css";
import "./Components/Css/StaffRights.css";
import "./Components/Css/TableSetup.css";
import "./Components/Css/Vacancy.css";
import "./Components/Css/WebsiteMngmt.css";
import Dashboard from "./Components/Dashboard";
import EditSubRights from "./Components/EditSubRights";
import Help from "./Components/Help";
import InsidePageRightsView from "./Components/InsidePageRightsView";
import LeadManagement from "./Components/LeadManagement";
import Login from "./Components/Login";
import Manuals from "./Components/Manuals";
import OnboadingSideTab from "./Components/OnboadingSideTab";
import ProfileSettings from "./Components/ProfileSettings";
import ReplyToTicket from "./Components/ReplyToTickect";
import Report from "./Components/Reports";
import RestaurantEnquiry from "./Components/RestaurantEnquiry";
import RestaurantSetup from "./Components/RestaurantSetup";
import SubscriptionManagement from "./Components/SubscriptionManagement";
import SuccessPage from "./Components/Success";
import ViewCareer from "./Components/ViewCareer";
import ViewDesignation from "./Components/ViewDesignation";
import ViewFaq from "./Components/ViewFaq";
import ViewKB from "./Components/ViewKB";
import ViewSearchMaster from "./Components/ViewSearchMaster";
import ViewStaff from "./Components/ViewStaff";
import ViewStaffRights from "./Components/ViewStaffRights";
import ViewSubRights from "./Components/ViewSubRights";
import WebsiteMngt from "./Components/WebsiteMngmt";
import AnalyticsNew from "./Components/AnalyticsNew";
import "./Components/Css/Pagination.css";

function App() {
  useEffect(() => {
    console.log("Effect is running");
    const inputElements = document.getElementsByTagName("input");
    Array.from(inputElements).forEach((input) => {
      input.setAttribute("autocomplete", "off");
    });
  }, [Array]);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Working Screen */}
          {/* Login Screens */}
          <Route path="/" element={<Login />} />
          {/* Add and Edit Staff Pages */}
          <Route path="/View_Staff" element={<ViewStaff />} />
          <Route path="/Add_Staff" element={<AddStaff />} />
          <Route path="/edit_staff/:id" element={<AddStaff />} />
          {/* Profile Settings Pages */}
          <Route path="/Profile_Settings" element={<ProfileSettings />} />
          {/* Guest Management Pages */}
          <Route path="/lead_management" element={<LeadManagement />} />
          {/* Subscription Management Pages */}
          <Route
            path="/View_Subsciption"
            element={<SubscriptionManagement />}
          />
          {/* Restraurant Setup Pages */}
          <Route path="/View_Restaurants" element={<RestaurantSetup />} />
          
        
        
          {/* Website Settings Pages */}
          <Route path="/Website_Management" element={<WebsiteMngt />} />
          {/* Create, Edit and View Righst Pages */}
          <Route path="/Create_Staff_Rights" element={<CreateStaffRights />} />
          <Route path="/View_Staff_Rights" element={<ViewStaffRights />} />
          <Route
            path="/Edit_Staff_Rights/:id"
            element={<CreateStaffRights />}
          />
          <Route
            path="/Create_SubStaff_Rights/:id"
            element={<CreateSubStaffRights />}
          />
          <Route path="/View_Sub_Rights/:id" element={<ViewSubRights />} />
          <Route
            path="/Edit_SubStaff_Rights/:id"
            element={<CreateSubStaffRights />}
          />
          <Route path="/Edit_Sub_Rights" element={<EditSubRights />} />
          <Route
            path="/View_Inside_Page_Rights/:id"
            element={<InsidePageRightsView />}
          />
          <Route
            path="/Create_Inside_Page_Rights/:id"
            element={<CreateInsidePageRights />}
          />
          <Route path="/Add_Designation" element={<AddDesignation />} />
          <Route path="/Edit_Designation/:id" element={<AddDesignation />} />
          <Route path="/ViewDesignation" element={<ViewDesignation />} />
          {/* <Route path="/Analytics" element={<Analytics />} /> */}
          <Route path="/Analytics" element={<AnalyticsNew />} />
          {/* Help And Support Pages */}
          <Route path="/Manuals" element={<Manuals />} />
          <Route path="/Add_Faq" element={<Add_Faqs />} />
          <Route path="/View_Faq" element={<ViewFaq />} />
          <Route path="/View_KB" element={<ViewKB />} />
          <Route path="/Add_KB" element={<AddKB />} />
          <Route path="/Edit_KB/:id" element={<AddKB />} />
          <Route path="/Edit_Faq/:id" element={<Add_Faqs />} />
        
          {/* Search Master */}
          <Route path="/ViewSearchMaster" element={<ViewSearchMaster />} />
          <Route path="/Add_SearchMaster" element={<Add_SearchMaster />} />
          <Route path="/PlanManagement" element={<PlanManagement />} />
          <Route path="/Edit_SearchMaster/:id" element={<Add_SearchMaster />} />
          {/* Analytics and Reports Pages */}
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/help" element={<Help />} />
          <Route path="/Manuals/Create_Ticket" element={<CreateNewTicket />} />
          <Route
            path="/Manuals/Reply_Ticket/:ticketId"
            element={<ReplyToTicket />}
          />
          <Route path="/View_Reports" element={<Report />} />
          <Route
            path="/View_Restaurant_enquiry"
            element={<RestaurantEnquiry />}
          />
          {/**----------Add Restaurant------------ */}
          <Route path="/View_Onboading" element={<OnboadingSideTab />} />
          <Route path="/add_restaurant_new" element={<AddRestaurantNew />} />
          <Route
            path="/Edit_restaurant_new/:id"
            element={<AddRestaurantNew />}
          />{" "}
          <Route path="/ViewCareer" element={<ViewCareer />} />
          <Route path="/AddVacancy" element={<AddVacancy />} />
          <Route path="/success" element={<SuccessPage />} />
        </Routes>
        <ToastContainer />
      </BrowserRouter>
    </div>
  );
}

export default App;
